var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { trpc } from 'root/src/client/v2/trpc/trpc';
import { LIST_QUERY_STALE_TIME_MS } from 'root/src/client/v2/common/clients/queryClient';
import { useIsAuthenticated } from 'root/src/client/v2/auth/hooks/useIsAuthenticated';
import { SignInDialog } from 'root/src/client/v2/auth/features/SignInDialog/SignInDialog';
import { Button } from 'root/src/client/v2/common/components/ui/button';
import { toast } from 'root/src/client/v2/common/components/ui/sonner';
// Subscription state lives in a dedicated per-user query rather than the getDrop payload, so every
// notify button on the page (hero CTA, dare cards, details card) shares one cache entry and they all
// flip together on toggle.
export const useDropSubscription = (dropId, enabled) => {
    var _a;
    const utils = trpc.useUtils();
    const subscriptionQuery = trpc.drops.getDropSubscription.useQuery({ dropId }, { enabled, staleTime: LIST_QUERY_STALE_TIME_MS });
    const subscribeMutation = trpc.drops.subscribeToDrop.useMutation();
    const unsubscribeMutation = trpc.drops.unsubscribeFromDrop.useMutation();
    const toggle = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const next = !((_b = subscriptionQuery.data) !== null && _b !== void 0 ? _b : false);
        try {
            if (next) {
                yield subscribeMutation.mutateAsync({ dropId });
            }
            else {
                yield unsubscribeMutation.mutateAsync({ dropId });
            }
            toast.success(next ? 'We will notify you when this drop goes live' : 'Notifications turned off');
            void utils.drops.getDropSubscription.invalidate({ dropId });
        }
        catch (error) {
            toast.error(error instanceof Error ? error.message : 'Could not update notifications');
        }
    });
    return {
        subscribed: (_a = subscriptionQuery.data) !== null && _a !== void 0 ? _a : false,
        loading: subscribeMutation.isPending || unsubscribeMutation.isPending || subscriptionQuery.isLoading,
        toggle,
    };
};
// Callers decide when a drop is coming soon (isDropComingSoon) and render this in place of their
// accept CTA. Signed-out visitors get the same label behind the sign-in dialog, so the button never
// silently disappears for them.
export const DropNotifyButton = ({ dropId, className, label = 'Notify me', subscribedLabel = 'Subscribed for updates', variant = 'brand', }) => {
    const isAuthenticated = useIsAuthenticated();
    const { subscribed, loading, toggle } = useDropSubscription(dropId, isAuthenticated);
    if (!isAuthenticated) {
        return (<SignInDialog>
				<Button variant={variant} className={className}>{label}</Button>
			</SignInDialog>);
    }
    return (<Button variant={subscribed ? 'outline' : variant} loading={loading} onClick={() => { void toggle(); }} className={className}>
			{subscribed ? subscribedLabel : label}
		</Button>);
};
